const questionModule = {
  title: "ヘルプ",
  question1: "パスワードを忘れた場合にどうすれば いいですか。",
  answer1:
    "* をクリックして、身分証明をさせていただき、新しいパスワードが設定されます。",
  question2: "ログイン携帯番号が使えなくなる場合どうしますか。",
  answer2: "ページの下にある * をクリックしてPaymul事務局にご連絡ください。",
  kefu: "ログインできない？ *",
  linkKefu: "お問い合わせ",
  returnPassword: "パスワードを忘れてしまった方",
  help1: "ログインできません。",
  helpContent1: `Paymulへログインするには、利用規約、個人情報の取り扱いについてご確認の上、登録済の「携帯電話番号」と「パスワード」をご入力いただく必要がございます。新規登録の場合、携帯電話番号とSMSで受信した認証番号を入力すると登録が完了します。パスワードをお忘れの方はログイン画面で「パスワードをお忘れの方？」で携帯番号を入力し、パスワードのリセットをお願いいたします。<br/>
   ※末尾に空白があるとログインできないことがありますのでご注意ください。<br/>
   ※解決されない場合は、「お問い合わせ」よりご連絡をお願いいたします。`,
  help2: "お届け先を選択する方法を教えてください。",
  helpContent2: `新規登録の直後に、「お届け先を選択」の画面から自動的にお客様の位置を特定できます。位置情報に間違いがありましたら、手動でも検索可能です。また、ログイン後にお届け先を変更したい場合は、「マイページ」→「お届け先」から変更できます。`,
  help3: "どのような決済方法がありますか？",
  helpContent3:
    "お店によって異なります。チェックしたい店をクリックし、店舗詳細からお支払い方法を確認できます。また、画面下の検索からお支払い方法で絞り込むことができます。",
  help4: "アプリの言語を切り替えたい。",
  helpContent4:
    "ログイン後に、ホーム画面の右上に表示される地球マークから切り替え可能です。",
  help5: "店舗名で検索しても何も表示されません。",
  helpContent5:
    "お客様の検索した店がまだPaymulの加盟店舗になっておりません。順次エリア拡大して参りますので、是非お店をご紹介ください。加盟に関するお問い合わせは<a href='info@127jp.com'>info@127jp.com</a>へお願いいたします。",
  help6: "以前利用した店をもう一度利用したいが、店の名前を忘れました。",
  helpContent6: `お客様が一度ご利用になったお店は、注文履歴から確認できます。また、店画面の右上にある♡マークをクリックして、お気に入りリストに追加できます。
  その後マイページの「お気に入り」からお客様の♡マークが付いた店を確認できます。`,
  help7: "注文と違う商品が届いた／商品が届かない",
  helpContent7: `直接店舗へお問合せお願いいたします。<br/>
  ※店舗詳細の右上にある電話ボタンをクリックして店舗へ連絡できます。`,
  help8: "注文の取消（キャンセル）の方法について",
  helpContent8: `お手数ですが、直接店舗へご連絡をお願いいたします。店舗詳細の右上にある電話ボタンをクリックして店舗へ連絡できます。<br/>
  ※店舗や配達状況によっては、キャンセルできない場合もございます。`,
  help9: "不在で商品を受け取れなかった場合",
  helpContent9:
    "店舗詳細の右上にある電話ボタンをクリックして店舗へ直接ご連絡をお願いいたします。",
  help10: "注文の具体的な流れを教えてください。",
  helpContent10: `１）店のページを開き、「配達」「持帰」「ネット販売」のいずれかを選び、メニューの注文を行います。<br/>
  ２）注文後、注文画面から注文の状態が確認できます。「受付済」の表示は、店側でお客様の注文品の準備に取り掛かったという状態を表します。<br/>
  ３）店側がお客様の注文品の準備を完了し配達員に渡した後、注文状態が「配達中」になります。<br/>
  ４）注文した商品がお客様のところに届いたら、注文詳細画面の下に「受取確認」が表示されます。表示されない場合は画面を再読み込みしてください。<br/>
  ５）お客様が商品を確認し、「受取確認」をクリックすると、注文が完了し、店側がお客様の支払いを確認する流れに入ります。<br/>
  ６）店側の入金確認後に、お客様は注文履歴からコメントできるようになります。`
};
export default questionModule;
